export default __webpack_public_path__ + "static/media/轮播首图9.49a0e97d.jpg";